export const hasAllowedRole = (user, allowedRoles) => {
  if (!allowedRoles) return true;
  return (user?.roles || []).some(role => allowedRoles.includes(role));
};